<div class="reset-password-alliance content-without-footer d-flex">
    <app-sprintpay-reset-password
        class="position-absolute"
        [widthLogo]="'156'"
        [heightLogo]="'113'"
    ></app-sprintpay-reset-password>
</div>
